(() => {
  'use strict';
  const configEl = document.getElementById('sf-charm-details-data');
  if (!configEl) return;
  const config = JSON.parse(configEl.textContent);
  const missingPhoto = letter => 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="384" height="384" viewBox="0 0 384 384"><rect width="384" height="384" fill="#faf9f6"/><text x="192" y="180" text-anchor="middle" font-family="sans-serif" font-size="80" fill="#777">' + letter + '</text><text x="192" y="230" text-anchor="middle" font-family="sans-serif" font-size="24" fill="#555">Photo pending</text></svg>');
  const replacements = {};
  Object.entries(config.silver).forEach(([id, item]) => {
    replacements[id] = item.url ? item.url + '#sf-silver' : missingPhoto(item.letter);
  });
  document.querySelectorAll('script[data-anchor-points-catalog]').forEach(script => {
    const data = JSON.parse(script.textContent);
    let changed = false;
    (data.items || []).forEach(item => {
      if (replacements[item.variantId]) { item.imageUrl = replacements[item.variantId]; changed = true; }
    });
    if (changed) script.textContent = JSON.stringify(data);
  });
  const detailsURL = card => {
    const handle = config.handles[card.dataset.productId];
    if (!handle) return null;
    const url = new URL('/products/' + handle, location.origin);
    url.searchParams.set('variant', card.dataset.productVariantId);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  };
  function linkFor(card, imageLink) {
    const link = document.createElement('a');
    link.href = detailsURL(card);
    link.target = '_blank';
    link.rel = 'noopener';
    link.className = 'sf-charm-details' + (imageLink ? ' sf-charm-image-link' : ' sf-charm-title-link');
    link.draggable = false;
    link.setAttribute('aria-label', 'View details for ' + card.dataset.charmName + ' (opens in a new tab)');
    return link;
  }
  function enhance(builder) {
    builder.querySelectorAll('.charm_bar__collection-item').forEach(section => {
      const category = section.querySelector('h3')?.textContent.trim().toLowerCase() || '';
      const wanted = category === 'silver' ? 'silver' : /gold/.test(category) ? 'gold' : null;
      section.querySelectorAll('.charm_bar__charm-item').forEach(card => {
        if (!['10314819436694', '8606740021398'].includes(card.dataset.productId)) return;
        const variant = (card.dataset.charmName || '').split(' - ').pop();
        const metal = /(?:^|\s|\/)silver(?:$|\s|\/)/i.test(variant) ? 'silver' : /(?:^|\s|\/)gold(?:$|\s|\/)/i.test(variant) ? 'gold' : null;
        if (wanted && metal && wanted !== metal) card.setAttribute('data-sf-metal-hidden', '');
        else card.removeAttribute('data-sf-metal-hidden');
      });
    });

    builder.querySelectorAll('.charm_bar__charm-item:not([data-sf-details-ready])').forEach(card => {
      if (!detailsURL(card)) return;
      card.dataset.sfDetailsReady = 'true';
      const title = card.firstElementChild;
      if (title?.tagName === 'SPAN') {
        const link = linkFor(card, false);
        title.replaceWith(link); link.append(title);
      }
      const drag = card.querySelector('draggable-element');
      if (drag) {
        drag.classList.add('sf-charm-image-link');
        drag.dataset.sfDetailsHref = detailsURL(card);
        drag.setAttribute('role', 'link');
        drag.setAttribute('tabindex', '0');
        drag.setAttribute('aria-label', 'View details for ' + card.dataset.charmName + ' (opens in a new tab)');
        const src = replacements[card.dataset.productVariantId];
        if (src) {
          card.dataset.charmImageUrl = drag.dataset.charmImageUrl = src;
          const image = drag.querySelector('img');
          if (image && image.getAttribute('src') !== src) image.src = src;
          if (drag.myPopover && image) drag.myPopover.replaceChildren(image.cloneNode(true));
        }
      }
    });
  }
  let pointer = null;
  document.addEventListener('pointerdown', event => {
    const link = event.target.closest?.('.sf-charm-image-link');
    if (link && event.button === 0) pointer = {id:event.pointerId, link, x:event.clientX, y:event.clientY, moved:false, time:Date.now()};
  }, true);
  document.addEventListener('pointermove', event => {
    if (pointer && pointer.id === event.pointerId && Math.hypot(event.clientX-pointer.x, event.clientY-pointer.y)>8) pointer.moved = true;
  }, true);
  document.addEventListener('pointerup', event => {
    const current = pointer; pointer = null;
    if (!current || current.id !== event.pointerId) return;
    if (!current.moved && Math.hypot(event.clientX-current.x,event.clientY-current.y)<=8 && Date.now()-current.time<800) {
      window.open(current.link.dataset.sfDetailsHref, '_blank', 'noopener');
    }
  }, true);
  document.addEventListener('pointercancel', () => { pointer=null; }, true);
  document.addEventListener('click', event => {
    if (event.detail && event.target.closest?.('.sf-charm-image-link')) event.preventDefault();
  }, true);
  document.addEventListener('keydown', event => {
    const link = event.target.closest?.('.sf-charm-image-link');
    if (link && event.key === 'Enter') {
      event.preventDefault();
      window.open(link.dataset.sfDetailsHref, '_blank', 'noopener');
    }
  });
  function setup() {
    document.querySelectorAll('charm-bar-builder').forEach(builder => {
      if (builder.dataset.sfDetailsBound) return;
      builder.dataset.sfDetailsBound = 'true';
      enhance(builder);
      let scheduled = false;
      new MutationObserver(records => {
        if (scheduled || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('.charm_bar__charm-item:not([data-sf-details-ready])') || node.querySelector?.('.charm_bar__charm-item:not([data-sf-details-ready])'))))) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; enhance(builder); });
      }).observe(builder, {subtree:true, childList:true});
      const instruction = builder.querySelector('.sf-charm-category-picker p');
      if (instruction && !instruction.dataset.sfUpdated) {
        instruction.textContent += ' Tap a charm image or name for details in a new tab.';
        instruction.dataset.sfUpdated = 'true';
      }
    });
    setupProduct();
  }
  function setupProduct() {
    const section = document.querySelector('[data-section-type="product"][data-product-handle="mini-bubble-letter"]');
    if (!section || section.dataset.sfSilverBound) return;
    section.dataset.sfSilverBound = 'true';
    const gallery = section.querySelector('.product__media__wrapper');
    if (!gallery) return;
    const preview = document.createElement('figure');
    preview.className = 'sf-silver-product-preview'; preview.hidden = true;
    const image = document.createElement('img'); image.width=768; image.height=768;
    preview.append(image); gallery.prepend(preview);
    let active = '';
    function sync(event) {
      const id = String(event?.detail?.variant?.id || section.querySelector('form[data-product-form] input[name="id"]')?.value || section.querySelector('[data-product-select]')?.value || new URL(location.href).searchParams.get('variant') || '');
      if (id===active) return; active=id;
      const item=config.silver[id];
      gallery.classList.toggle('sf-show-silver-preview', !!item);
      preview.hidden=!item;
      if (item) { image.src=replacements[id]; image.alt='Mini bubble letter '+item.letter+' in silver'; }
    }
    section.addEventListener('change', () => { setTimeout(sync,0); setTimeout(sync,150); });
    document.addEventListener('theme:variant:change', sync);
    window.addEventListener('popstate',sync);
    const form = section.querySelector('form[data-product-form]');
    if (form) new MutationObserver(sync).observe(form, {subtree:true,attributes:true,attributeFilter:['value']});
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
  document.addEventListener('shopify:section:load',setup);
})();




(() => {
  if (!document.querySelector('charm-bar-builder')) return;
  customElements.whenDefined('draggable-element').then(() => {
    const prototype = customElements.get('draggable-element').prototype;
    if (prototype.sfLaptopDropAssist || typeof prototype.obtainDropTargetAtPoint !== 'function') return;
    prototype.sfLaptopDropAssist = true;
    const pointerDown = prototype.onPointerDown;
    const dragOffset = prototype.getDragOffsetY;
    const findTarget = prototype.obtainDropTargetAtPoint;
    prototype.onPointerDown = function (event) {
      this.sfPointerType = event.pointerType;
      return pointerDown.call(this, event);
    };
    prototype.getDragOffsetY = function (height) {
      if (this.sfPointerType === 'mouse' && this.closest('charm-bar-builder')) return 0;
      return dragOffset.call(this, height);
    };
    prototype.obtainDropTargetAtPoint = function (x, y) {
      const direct = findTarget.call(this, x, y);
      if (direct || this.sfPointerType !== 'mouse') return direct;
      const builder = this.closest('charm-bar-builder');
      const reference = builder && builder.querySelector('.charm_bar__reference');
      const hit = document.elementFromPoint(x, y);
      if (!reference || !hit || !reference.contains(hit)) return null;
      let nearest = null;
      let nearestDistance = Infinity;
      reference.querySelectorAll('.charm_bar__point[data-drop-target]').forEach(point => {
        const rect = point.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const distance = Math.hypot(x - rect.left - rect.width / 2, y - rect.top - rect.height / 2);
        const radius = Math.max(44, Math.max(rect.width, rect.height) * 0.9);
        if (distance <= radius && distance < nearestDistance) {
          nearest = point;
          nearestDistance = distance;
        }
      });
      return nearest;
    };
    document.querySelectorAll('charm-bar-builder').forEach(builder => {
      builder.dataset.sfDropAssist = 'laptop';
    });
  });
})();
